import View from './view'

export const Contacts = View
